import { cn } from '@Core/Helpers';
import React, { ReactNode } from "react";

const ModalTitle = (
    { children, className = '' }: { children: ReactNode, className?: string }
) => (
    <h1 className={cn('text-3xl font-bold', className)}>{children}</h1>
);

export default ModalTitle;
